import navigation from '../navigation/rbmc.navigation';
import subShopNavigation from '../rbmc.subshop-selector';

const mobileNavigation = {
    /**
     * @deprecated
     */
    mobileMenuNavigation() {
        let mobileNavCategory   = $('.page-header__mobile-nav-item'),
            mobileNavBackButton = $('.page-header__mobile-nav-back'),
            mobileNav           = $('.page-header__mobile-nav'),
            mobileNavSubshops   = $('.page-header__mobile-nav-item--subshops');
        mobileNavCategory.on('click', function () {
            let $this = $(this);
            $this.siblings('.page-header__mobile-sub-nav')
                 .addClass('page-header--move-in');
            mobileNav.scrollTop(0);
            $this.closest('.page-header--real-dimension')
                 .parent().addClass('disable-overflow');
        });

        mobileNavBackButton.on('click', function () {
            let $this = $(this);
            $this.parent().parent()
                 .removeClass('page-header--move-in');
            $this.parents('.disable-overflow')
                 .removeClass("disable-overflow");
        });

        mobileNavSubshops.one('click', () => {
            subShopNavigation.unveilSubshopLogos();
        })
    },
    /**
     * @deprecated
     */
    mobileMenuOpenClose() {
        let mobileNavClose   = $('.page-header__side-nav-close-wrapper'),
            mobileNavOpen    = $('.page-header__side-nav-button'),
            mobileNavWrapper = $('.page-header__mobile-nav-wrapper'),
            body             = $('body');

        mobileNavOpen.on('click', function () {
            mobileNavWrapper.removeClass('d-none');
            body.addClass('disable-overflow');
            navigation.setGreyout(true);
        });

        mobileNavClose.on('click', function () {
            mobileNavWrapper.addClass('d-none');
            mobileNavWrapper.find('.page-header--move-in')
                            .removeClass('page-header--move-in');
            mobileNavWrapper.find('.disable-overflow')
                            .removeClass('disable-overflow');
            body.removeClass('disable-overflow');
            navigation.setGreyout(false);
        });
    },
};

export default mobileNavigation;
